export default function params(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
      return {
        ...state,
        param: action.param,
      }
    default:
      return state;
  }
}